const PROGRESS_STATUS = {
	waiting: "승인대기",
	evaluate: "승인",
	complete: "완료",
	rejection: "반려",
};

const currentStatus = (status) => {
	switch (status) {
		case PROGRESS_STATUS.waiting:
			return "waiting";
		case PROGRESS_STATUS.evaluate:
			return "evaluate";
		case PROGRESS_STATUS.complete:
			return "complete";
		case PROGRESS_STATUS.rejection:
			return "rejection";
		default:
			return "";
	}
};

export default currentStatus;
